import {team, TeamMemberSlug} from './team'

export const useHelpCenterContent = () => ({
  title: 'help-center.help-title',
  searchPlaceholder: 'help-center.help-search-placeholder',
  searchNoResultsText: 'no-results-found',
  author: team[TeamMemberSlug.janBuza],
  writtenByText: 'help-written-by',
  learnMoreText: 'help-center.help-learn-more-article',
})
